import { SnappeaJS, jsonReplace } from './Core';
import { on, off } from './Events';
import { requestAPI, getThisSDKVersionName } from './Core';
export var DownloadStatus;
(function (DownloadStatus) {
    DownloadStatus["READY"] = "ready";
    DownloadStatus["DOWNLOADING"] = "downloading";
    DownloadStatus["SUCCESS"] = "success";
    DownloadStatus["FAILED"] = "failed";
    DownloadStatus["OFFLINE"] = "offline"; // 版权歌曲处于已下线状态
})(DownloadStatus || (DownloadStatus = {}));
export { jsonReplace };
/**
 * @public
 */
class Hybrid {
    isDebug = false;
    static _instance;
    /**
     * 获取实例
     */
    static instance() {
        /* eslint-disable */
        if (!this._instance) {
            const __mb__jsbridge__ = window.__mb__jsbridge__;
            if (__mb__jsbridge__) {
                this._instance = __mb__jsbridge__;
            }
            else {
                this._instance = new Hybrid();
            }
            window.SnappeaJS = SnappeaJS;
            window.__mb__jsbridge__ = this._instance;
        }
        else {
            console.log('lazy loading singleton has created');
        }
        /* eslint-enable */
        return this._instance;
    }
    on = on;
    off = off;
    /**
     * 是否在端内
     */
    isSupportHybrid() {
        return getThisSDKVersionName()
            .then(version => {
            return Promise.resolve(!!version);
        })
            .catch(() => {
            return Promise.resolve(false);
        });
    }
    /**
     * 开启debug 模式
     */
    toggleDebug(isOpen) {
        const switcher = isOpen ? 1 : 0;
        this.isDebug = !!switcher;
        console.debug(`toggleDebug:${this.isDebug}`);
        return requestAPI({
            api: 'com.dywx.hybrid.handler.DebugHandler/toggleDebug',
            params: { debug: switcher },
            needResp: false
        });
    }
    /**
     * 复制指定文本到剪贴板
     */
    copyText(content) {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.SystemToolHandler/copyToClipboard',
            params: { content: content },
            needResp: false
        });
    }
    /**
     * 向客户端汇报页面刷新结果
     */
    reportPageRefresh(isSuccess = true) {
        requestAPI({
            api: 'com.dywx.hybrid.event.RefreshEvent/onRefreshFinished',
            params: {
                success: isSuccess
            }
        });
    }
    /**
     * 获取当前App的SDK版本号，
     */
    getThisSDKVersionCode() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.SdkInfoHandler/getSdkVersionCode',
            useCache: true
        });
    }
    /**
     * 执行返回行为
     */
    back() {
        requestAPI({
            api: 'com.dywx.hybrid.event.MBack/back',
            params: { value: 1 },
            needResp: false
        });
    }
    /**
     * 关闭当前WebView
     */
    closeWebview() {
        requestAPI({
            api: 'com.dywx.hybrid.event.MBack/back',
            params: { value: 2 },
            needResp: false
        });
    }
    /**
     * 获取手机SN号码
     */
    getSN() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.DeviceInfoHandler/getSN',
            useCache: true
        });
    }
    /**
     * 获取手机Model
     */
    getModel() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.DeviceInfoHandler/getModel',
            useCache: true
        });
    }
    /**
     * 获取Android版本名
     */
    getAndroidVersion() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.DeviceInfoHandler/getAndroidVersion',
            useCache: true
        });
    }
    /**
     * 获取Android api Level
     */
    getAndroidSDKLevel() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.DeviceInfoHandler/getAndroidSdkLevel',
            useCache: true
        });
    }
    /**
     * 获取语言
     */
    getLanguage() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.DeviceInfoHandler/getLanguage',
            useCache: true
        });
    }
    /**
     * 获取region
     */
    getRegion() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.DeviceInfoHandler/getRegion',
            useCache: true
        });
    }
    /**
     * 获取country
     */
    getCountry() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.DeviceInfoHandler/getCountry',
            useCache: true
        });
    }
    /**
     * 获取udid
     */
    getUDID() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.DeviceInfoHandler/getUDID',
            useCache: true
        });
    }
    /**
     * 获取网络类型
     */
    getNetworkType() {
        return requestAPI({
            api: 'com.dywx.hybrid.event.NetworkEvent/getNetworkType'
        });
    }
    /**
     * 判断网络是否可用 isNetworkAvailable: 0 | 1
     */
    isNetworkAvailable() {
        return requestAPI({
            api: 'com.dywx.hybrid.event.NetworkEvent/isNetworkAvailable'
        });
    }
    /**
     * 获取网络名称
     */
    getNetworkName() {
        return requestAPI({
            api: 'com.dywx.hybrid.event.NetworkEvent/getNetworkName'
        });
    }
    /**
     * 获取网络模式(移动网络下)
     */
    getNetworkMode() {
        return requestAPI({
            api: 'com.dywx.hybrid.event.NetworkEvent/getNetworkMode'
        });
    }
    /**
     * 获取网络模式(移动网络下) 短名字
     */
    getShortNetworkMode() {
        return requestAPI({
            api: 'com.dywx.hybrid.event.NetworkEvent/getShortNetworkMode'
        });
    }
    /**
     * 是否在使用移动网
     */
    isMobileNetwork() {
        return requestAPI({
            api: 'com.dywx.hybrid.event.NetworkEvent/isMobileNetwork'
        });
    }
    /**
     * 是否在使用wifi网络
     */
    isWlanNetwork() {
        return requestAPI({
            api: 'com.dywx.hybrid.event.NetworkEvent/isWlanNetwork'
        });
    }
    /**
     * 获取当前App的版本名
     */
    getThisVersionName() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.AppInfoHandler/getVersion',
            useCache: true
        });
    }
    /**
     * 获取当前App的版本号
     */
    getThisVersionCode() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.AppInfoHandler/getVersionCode',
            useCache: true
        });
    }
    /**
     * 获取当前App的名称
     */
    getThisPackageName() {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.AppInfoHandler/getPackageName',
            useCache: true
        });
    }
    /**
     * 获取指定App的版本名
     */
    getPackageVersionName(packageName) {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.AppInfoHandler/getPackageVersionName',
            params: {
                packageName: packageName
            }
        });
    }
    /**
     * 获取指定App的版本号
     */
    getPackageVersionCode(packageName) {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.AppInfoHandler/getPackageVersionCode',
            params: {
                packageName: packageName
            }
        });
    }
    /**
     * 检查指定的App是否已经安装
     */
    isPackageInstalled(packageName) {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.AppInfoHandler/isPackageInstalled',
            params: {
                packageName: packageName
            }
        });
    }
    /**
     * 普通打开页面
     */
    startActivity(intentUri) {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.IntentHandler/startActivity',
            params: {
                intentUri: intentUri
            }
        });
    }
    /**
     * 开启服务
     */
    startService(intentUri) {
        return requestAPI({
            api: 'com.dywx.hybrid.handler.IntentHandler/startService',
            params: {
                intentUri: intentUri
            }
        });
    }
    /**
     * 发送广播
     */
    sendBroadcast(intentUri) {
        requestAPI({
            api: 'com.dywx.hybrid.handler.IntentHandler/sendBroadcast',
            params: {
                intentUri: intentUri
            },
            needResp: false
        });
    }
    /**
     * 本地埋点
     */
    trackEvent(event, properties) {
        console.log('trackEvent');
        console.log(event, properties);
        return requestAPI({
            api: 'com.dywx.hybrid.handler.ReportHandler/trackEvent',
            params: {
                event: event,
                properties: JSON.stringify(properties)
            },
            needResp: false
        });
    }
    /**
     * 获取登录用户信息
     */
    /**
     * 获取登录用户信息
     */
    getUserInfo(autoLogin = false) {
        const self = this;
        const loadUser = () => requestAPI({
            api: 'com.pugc.premium.feature.web.handler.AccountHandler/getUserInfo'
        });
        return new Promise((resolve, reject) => {
            loadUser()
                .then(data => {
                if (autoLogin && !data) {
                    const visibleHandler = () => {
                        if (document.visibilityState === 'visible') {
                            loadUser().then(resolve).catch(reject);
                            document.removeEventListener('visibilitychange', visibleHandler);
                        }
                    };
                    document.addEventListener('visibilitychange', visibleHandler);
                    self.login();
                }
                else {
                    resolve(data);
                }
            })
                .catch(reject);
        });
    }
    /**
     * 调起客户端的登录
     */
    login() {
        return requestAPI({
            api: 'com.pugc.premium.feature.web.handler.AccountHandler/login'
        });
    }
    /**
     * 分享视频
     */
    shareVideo(videoInfo) {
        return requestAPI({
            api: 'com.pugc.premium.feature.web.handler.ShareHandler/shareVideo',
            params: {
                videoInfo: JSON.stringify(videoInfo)
            }
        });
    }
    /**
     * 分享链接
     */
    shareLink(linkInfo) {
        return requestAPI({
            api: 'com.pugc.premium.feature.web.handler.ShareHandler/shareLink',
            params: {
                shareLinkInfo: JSON.stringify(linkInfo)
            }
        });
    }
    /**
     * 添加活动监听下载、分享，并弹窗
     */
    addCampaignTrigger(campaignInfo) {
        return requestAPI({
            api: 'com.pugc.premium.feature.web.handler.CampaignHandler/addCampaignTrigger',
            params: {
                trigger: JSON.stringify(campaignInfo)
            }
        });
    }
    /**
     * 判断活动任务是否完成
     */
    isCampaignCompleted(campaignId) {
        return requestAPI({
            api: 'com.pugc.premium.feature.web.handler.CampaignHandler/isCampaignCompleted',
            params: {
                campaignId: campaignId
            }
        });
    }
    // LarkPlayer 扩展部分
    /**
     * 分享链接
     * shareLinkInfo: {
     *    desc: string;
     *    urlLink: string;
     *    imageUrl?: string;
     *    // 分享来源
     *    source?: string;
     * }
     * @returns {Promise<T>}
     */
    shareLinkLP(shareLinkInfo) {
        return requestAPI({
            api: 'com.dywx.v4.web.handler.ShareHandler/shareLink',
            params: {
                shareLinkInfo: JSON.stringify(shareLinkInfo)
            }
        });
    }
    /**
     * card 跳转页面
     * @returns {Promise<T>}
     */
    cardClick(action, title) {
        return requestAPI({
            api: 'com.dywx.v4.web.handler.ActionHandler/handleAction',
            params: {
                title: title,
                action: action
            }
        });
    }
    /**
     * 播放歌曲列表
     * @returns {Promise<T>}
     */
    playAll(playlist, song, source) {
        requestAPI({
            api: 'com.dywx.v4.web.handler.MediaHandler/handlePlayAll',
            params: {
                playlist: JSON.stringify(playlist),
                song: JSON.stringify(song),
                stayCurrentPage: true
            }
        });
        requestAPI({
            api: 'com.dywx.v4.web.handler.MediaHandler/handlePlayAll',
            params: {
                playlist: JSON.stringify(playlist),
                song: JSON.stringify(song)
            }
        });
        return requestAPI({
            api: 'com.dywx.v4.web.handler.MediaHandler/handlePlayAll',
            params: {
                playlist: JSON.stringify(playlist),
                song: JSON.stringify(song),
                stayCurrentPage: true,
                source
            }
        });
    }
    /**
     * 播放歌曲列表 v 4.14 使用新的数据结构
     * @returns {Promise<T>}
     */
    play(playlist, song, source) {
        return requestAPI({
            api: 'com.dywx.v4.web.handler.MediaHandler/handlePlay',
            params: {
                playlist: JSON.stringify(playlist),
                song: JSON.stringify(song),
                stayCurrentPage: true,
                source
            }
        });
    }
    /**
     * 打开歌曲菜单 V4.14 使用新的数据结构
     * @returns {Promise<T>}
     */
    song(song, source) {
        console.log('song');
        return requestAPI({
            api: 'com.dywx.v4.web.handler.MediaHandler/handleSongOperation',
            params: {
                song: JSON.stringify(song),
                source
            }
        });
    }
    /**
     * 打开歌曲菜单
     * @returns {Promise<T>}
     */
    songMenu(song, screenView, source) {
        requestAPI({
            api: 'com.dywx.v4.web.handler.MediaHandler/handleSongMenu',
            params: {
                song: JSON.stringify(song),
                screenView: screenView
            }
        });
        return requestAPI({
            api: 'com.dywx.v4.web.handler.MediaHandler/handleSongMenu',
            params: {
                song: JSON.stringify(song),
                source
            }
        });
    }
    /**
     * 播放歌曲列表
     * @returns {Promise<T>}
     */
    seekToPosition() {
        console.log('seekToPosition');
        return requestAPI({
            api: 'com.dywx.v4.web.handler.MediaHandler/seekToPosition',
            params: {
                time: 10000
            }
        });
    }
    /**
     * 获取 App 主题
     * @returns {Promise<T>}
     */
    getAppMode() {
        console.log('getAppMode');
        return requestAPI({
            api: 'com.dywx.v4.web.handler.ConfigHandler/getAppMode'
        });
    }
    /**
     * 暂停
     * @returns {Promise<T>}
     */
    pause() {
        alert('pause');
        return requestAPI({
            api: 'com.dywx.v4.web.handler.MediaHandler/pause'
        });
    }
    /**
     * 状态栏
     * @returns {Promise<T>}
     */
    navigationBar(isDark) {
        return requestAPI({
            api: 'com.dywx.v4.web.handler.ConfigHandler/navigationBarDarkMode',
            params: {
                dark: isDark
            }
        });
    }
    /**
     * 状态栏
     * @returns {Promise<T>}
     */
    statusBar(isDark) {
        return requestAPI({
            api: 'com.dywx.v4.web.handler.ConfigHandler/statusBarDarkMode',
            params: {
                dark: isDark
            }
        });
    }
    /**
     * 是否有小窗授权
     * @returns {Promise<T>}
     */
    checkDrawOverBeforePlay() {
        console.log('checkDrawOverBeforePlay');
        //false 是不需要申请权限
        return requestAPI({
            api: 'com.dywx.v4.web.handler.ConfigHandler/checkDrawOverBeforePlay'
        });
    }
    /**
     * 向客户端请求下载版权歌曲
     * @note: v5.4版本加入了这个API的支持
     * @note: 参数songList,source只是用于数据上报
     * @returns {Promise<T>}
     */
    request2Download(songList, song, source) {
        return requestAPI({
            api: 'com.dywx.v4.web.handler.DownloadHandler/startDownload',
            params: {
                playlist: songList.map(song => JSON.stringify(song)),
                song: JSON.stringify(song),
                source
            }
        });
    }
    /**
     * 页面初始加载的时候，向客户端询问特定歌曲的下载状态
     * @note: v5.4版本加入了这个API的支持
     * @returns {Promise<T>}
     */
    getDownloadStatus(downloadUrl, title, songId) {
        return requestAPI({
            api: 'com.dywx.v4.web.handler.DownloadHandler/getDownloadStatus',
            params: {
                downloadUrl,
                title,
                id: songId
            }
        });
    }
    /**
     * 歌曲有「在线音乐」和「本地的版权音乐」之分，本方法是用于播放「本地的版权音乐」
     *
     * @note: v5.4版本加入了这个API的支持
     * @returns {'0' | '1'} '0'代表需要解锁才能播放，'1'代表可以直接播放
     */
    playLocalSong(songList, song, source, versionCode) {
        const LP_5_9_0 = 25090000; // LP 版本： @v5.9.0
        const iSupportCopyrightOffline = versionCode >= LP_5_9_0;
        return requestAPI({
            api: 'com.dywx.v4.web.handler.MediaHandler/handleLocalPlay',
            params: {
                song: JSON.stringify(song),
                stayCurrentPage: true,
                source,
                ...(iSupportCopyrightOffline ? { playlist: JSON.stringify(songList) } : {})
            }
        });
    }
    /**
     * 获取客户端播放数据
     *
     * @note: v5.48版本加入了这个API的支持
     * @returns {Promise<T>}
     */
    getUserPlayInfo() {
        return requestAPI({
            api: 'com.dywx.larkplayer.feature.web.handler.UserHandler/getUserPlayInfo'
        });
    }
    /**
     * 跳转页面
     *
     * @note: v5.48版本加入了这个API的支持
     * @param isFinish 是否关闭当前 Webview
     * @returns {Promise<T>}
     */
    handleAction(action, isFinish = false, title = '') {
        return requestAPI({
            api: 'com.dywx.v4.web.handler.ActionHandler/handleAction',
            params: {
                title,
                action,
                isFinish
            }
        });
    }
    /**
     * 跳端外浏览器
     *
     * @note: v5.48版本加入了这个API的支持
     * @returns {Promise<T>}
     */
    handleBrowserAction(url) {
        return requestAPI({
            api: 'com.dywx.v4.web.handler.ActionHandler/handleBrowserAction',
            params: {
                url
            }
        });
    }
    /**
     * 听歌报告
     *
     * @url: https://docs.google.com/document/d/1-Yv2SgLjlRgf9H6gLrDC1PyGz3Mpi04JwmYI5EEV5DM/edit?usp=sharing
     * @note: v5.64 版本加入了这个 API 的支持
     * @returns {Promise<T>}
     */
    queryUserActivity(params) {
        const newParams = {
            type: params.type,
            group_by: params.groupBy,
            filter: params.filter,
            filter_values: params.filterValues,
            order_by: params.orderBy,
            limit: params.limit
        };
        return requestAPI({
            api: 'com.dywx.larkplayer.feature.web.handler.UserHandler/queryUserActivity',
            params: newParams
        });
    }
}
export var QueryUserActivityType;
(function (QueryUserActivityType) {
    /**
     * 听歌总时长、总首数、总次数
     */
    QueryUserActivityType["TOTAL_PLAY_INFO"] = "TOTAL_PLAY_INFO";
    /**
     * top 播放歌曲信息
     */
    QueryUserActivityType["TOP_MEDIA_PLAY_INFO"] = "TOP_MEDIA_PLAY_INFO";
    /**
     * 关联的自建歌单信息
     */
    QueryUserActivityType["MEDIA_PLAYLIST_INFO"] = "MEDIA_PLAYLIST_INFO";
    /**
     * top 播放歌曲天数
     */
    QueryUserActivityType["TOP_MEDIA_PLAY_DAY"] = "TOP_MEDIA_PLAY_DAY";
})(QueryUserActivityType || (QueryUserActivityType = {}));
export var QueryUserActivityGroupBy;
(function (QueryUserActivityGroupBy) {
    /**
     * 媒体文件路径(媒体库主键 _id)
     */
    QueryUserActivityGroupBy["MEDIA_LOCATION"] = "MEDIA_LOCATION";
    /**
     * 自建歌单 id(自建歌单名称)
     */
    QueryUserActivityGroupBy["PLAYLIST_ID"] = "PLAYLIST_ID";
    /**
     * 按天统计 date(stop_time_stamp/1000, 'unixepoch', 'localtime')
     */
    QueryUserActivityGroupBy["DAY"] = "DAY";
})(QueryUserActivityGroupBy || (QueryUserActivityGroupBy = {}));
export var QueryUserActivityOrderBy;
(function (QueryUserActivityOrderBy) {
    /**
     * 按照播放时间倒序
     */
    QueryUserActivityOrderBy["PLAY_TIME"] = "PLAY_TIME";
    /**
     * 按照播放次数倒序
     */
    QueryUserActivityOrderBy["PLAY_COUNT"] = "PLAY_COUNT";
    /**
     * 按照播放天数倒序
     */
    QueryUserActivityOrderBy["PLAY_DAY"] = "PLAY_DAY";
})(QueryUserActivityOrderBy || (QueryUserActivityOrderBy = {}));
let hybrid;
if (typeof window !== 'undefined') {
    hybrid = Hybrid.instance();
}
export default hybrid;
